import { Formik } from "formik";
import { Box } from "@mui/material";
import Header from "../../components/Header";
import { useFilialForm } from "../../hooks/pages/useFilialForm";
import FilialFormData from "./_partials/FilialFormData";
import useUserStore from "../../store/userStore";

export default function FilialCreate() {
  const { permissions } = useUserStore(state => state);
  const { initialValues, validationSchema, onSubmit, estados, handleCep } =
    useFilialForm();

  const permission =
    permissions?.filter(p => p.pagina?.Nome === "Filial")[0] ?? null;

  return (
    <Box m="20px">
      {/* HEADER */}
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Header title="Filial" subtitle="Bem vindo ao criar filial" />
      </Box>
      <Box>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={onSubmit}
          enableReinitialize
        >
          {({
            values,
            errors,
            touched,
            handleBlur,
            handleChange,
            isSubmitting,
            setFieldValue
          }) => {
            return (
              <FilialFormData
                values={values}
                errors={errors}
                touched={touched}
                handleBlur={handleBlur}
                handleChange={handleChange}
                isSubmitting={isSubmitting}
                setFieldValue={setFieldValue}
                estados={estados}
                handleCep={handleCep}
                permission={permission}
              />
            );
          }}
        </Formik>
      </Box>
    </Box>
  );
}
